import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";

export default function Uslovi() {
    return (
        <div>
            <Header />
            <Hero title="Uslovi korištenja" subtitle="" />
            <article className="mt-16 mb-32 max-w-screen-lg mx-auto px-6 lg:px-0 prose prose-md space-y-5 leading-8">
                <p>
                    <h3>1. Opšte</h3>
                </p>
                <p>
                    Korišćenjem bilo kog djela portala dzobs.com u vlasništvu
                    Računarsko programiranje "Dzobs.com" Nikola Novaković s.p.
                    Banja Luka (u nastavku samo Dzobs.com), automatski
                    prihvatate sva aktuelna pravila korišćenja. Korisnici su
                    dužni da redovno čitaju pravila korišćenja, te se smatra da
                    su korisnici kontinuiranim korišćenjem portala dzobs.com ili
                    bilo kojeg njegovog djela, u svakom trenutku upoznati s
                    aktuelnim pravilima korišćenja, te da su ih razumjeli u
                    cjelosti. Nijedan dio portala dzobs.com ne smije se
                    koristiti u nezakonite svrhe kao i za promovisanje istih.
                </p>

                <p>
                    <h3>2. Portal Dzobs.com</h3>
                </p>
                <p>
                    Računarsko programiranje "Dzobs.com" Nikola Novaković s.p.
                    Banja Luka korisnicima u dobroj namjeri obezbjeđuje
                    korišćenje sadržaja portala Dzobs.com. Svi korisnicima imaju
                    pravo da besplatno koriste sadržaje portala Dzobs.com,
                    ukoliko ne krše pravila korišćenja. Portal dzobs.com sastoji
                    se od vlastitih sadržaja, sadržaja partnera i oglašivača,
                    besplatnih sadržaja, sadržaja kreiranih od strane korisnika
                    i linkova na spoljne stranice. Portal Dzobs.com sadržaje
                    objavljuje u dobroj namjeri. Sve sadržaje portala Dzobs.com
                    koristite na vlastitu odgovornost i Dzobs.com se ne može
                    smatrati odgovornim za bilo kakvu štetu nastalu korišćenjem.
                    Pristup portalu Dzobs.com i svim njegovim sadržajima
                    dozvoljen je osobama bilo kog uzrasta.
                </p>

                <p>
                    <h3>3. Autorska prava</h3>
                </p>
                <p>
                    Portal Dzobs.com polaže autorska prava na sve vlastite
                    sadržaje (tekstualne, vizuelne i audio materijale, baze
                    podataka i programerski kod). Neovlašćeno korišćenje bilo
                    kog djela sadžaja portala smatra se kršenjem autorskih prava
                    portala Dzobs.com i podložno je tužbi. Neovlašćeno
                    korišćenje bilo kog djela portala bez dozvole vlasnika
                    autorskih prava (Dzobs.com, partneri, korisnici...) smatra
                    se kršenjem autorskih prava i podložno je tužbi. Ukoliko
                    smatrate da su Dzobs.com povrijedila vaša autorska prava,
                    slučaj će biti odmah razmotren, a sporni sadržaji biće
                    uklonjeni odmah po eventualnom ustanovljavanju istinitosti
                    sadržaja žalbe.
                </p>

                <p>
                    <h3>4. Linkovi na spoljne stranice</h3>
                </p>
                <p>
                    Dzobs.com sadrži linkove na web stranice izvan vlastitog
                    portala. Dzobs.com linkove objavljuje u dobroj namjeri i ne
                    mogu se smatrati odgovornim za sadržaje izvan portala.
                </p>

                <p>
                    <h3>5. Privatnost</h3>
                </p>
                <p>
                    Dzobs.com štiti privatnost korisnika u najvećoj mogućoj
                    mjeri i u skladu sa Pravilima o zaštiti privatnosti.
                    Dzobs.com se obavezuje da će u dobroj namjeri koristiti
                    podatke dobijene od korisnika tokom korišćenja portala, te
                    da privatne podatke neće distribuirati, niti prodavati
                    trećoj strani, osim uz dozvolu korisnika. Dzobs.com mogu u
                    skladu sa zakonom prikupljati određene podatke o korisnicima
                    dobijene tokom korišćenja portala (isključivo podaci o
                    računaru i podaci o Internet provajderu) ili podatke unešene
                    u postupku registracije. Ove podatke Dzobs.com koristi kako
                    bi imao informacije o korisnicima koji ga koriste, te na taj
                    način poboljšao portal i njegove sadržaje dodatno usmjerio i
                    prilagodio publici koja ga posjećuje. Na osnovu tih podataka
                    saznajemo koji su sadržaji najpopularniji među kojom
                    publikom. Dzobs.com obavezuje se da prikupljene privatne
                    podatke, poput e-mail adrese, imena i prezimena, neće bez
                    dozvole svakog pojedinačnog korisnika prodavati, niti
                    distribuirati, osim demografskih podataka za grupu korisnika
                    bez odavanja privatnih podataka. Dzobs.com se obavezuje da
                    će čuvati privatnost korisnika portala, osim u slučaju
                    teškog kršenja pravila Dzobs.com portala ili nezakonitih
                    aktivnosti korisnika.
                </p>

                <p>
                    <h3>6. Korisnički sadržaj</h3>
                </p>
                <p>
                    Dzobs.com zadržava pravo da u potpunosti kontroliše objavu
                    sadržaja koji su poslali korisnici, poput komentara,
                    iskustava o kompanijama i oglasa za posao. Dzobs.com može
                    bez obrazloženja i prethodne najave odbiti da objavi ili
                    naknadno ukinuti objavu prethodno objavljenog sadržaja
                    ukoliko se procijeni da takav sadržaj krši zakon, otkriva
                    povjerljive informacije, sadrži govor mržnje ili su
                    korisnici bili prisiljeni da ga ostave.
                </p>

                <p>
                    <h3>7. Modifikovanje i promjene pravila</h3>
                </p>
                <p>
                    Dzobs.com zadržava pravo da bez najave povremeno promijeni
                    ili modifikuje pravila. O važnim promjenama i dopunama
                    Dzobs.com može obavijestiti korisnike putem e-maila ili
                    objavljivanjem na portalu. Korišćenjem bilo kog sadržaja na
                    portalu Dzobs.com smatra se da ste upoznati sa najnovijim
                    pravilima.
                </p>
                <p>
                    <em>Poslednja izmjena</em>{" "}
                    <strong>12. februar 2022.</strong>
                </p>
            </article>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
